import React from 'react';
import ArrowUp from 'lucide-react/dist/esm/icons/arrow-up';
import ArrowDown from 'lucide-react/dist/esm/icons/arrow-down';
import ArrowUpDown from 'lucide-react/dist/esm/icons/arrow-up-down';

interface SortableHeaderProps {
  label: string;
  field: string;
  currentSort: string;
  currentDir: 'asc' | 'desc';
  onSort: (field: string, dir: 'asc' | 'desc') => void;
  align?: 'left' | 'right';
}

const SortableHeader: React.FC<SortableHeaderProps> = ({
  label, field, currentSort, currentDir, onSort, align = 'left',
}) => {
  const isActive = currentSort === field;
  const handleClick = () => {
    if (isActive) {
      onSort(field, currentDir === 'asc' ? 'desc' : 'asc');
    } else {
      onSort(field, 'asc');
    }
  };

  return (
    <th
      onClick={handleClick}
      className={`${align === 'right' ? 'text-right' : 'text-left'} px-4 py-3 text-xs font-semibold text-content-muted uppercase tracking-wider cursor-pointer select-none hover:text-content-secondary transition-colors group whitespace-nowrap`}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {isActive ? (
          currentDir === 'asc' ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUpDown size={12} className="opacity-0 group-hover:opacity-50 transition-opacity" />
        )}
      </span>
    </th>
  );
};

export default SortableHeader;
